import { integrationOptions } from "../../../../partner-settings/validation-management/requirement-management/integrationOptions";

export const INTEGRATION_FILTER_REGIONS = [
  "LAM",
  "NAM",
  "EMEA",
  "APAC",
  "Global",
  "Internal",
] as const;

export const INTEGRATION_FILTER_VALIDATION_STATUS_OPTIONS = [
  "Completed",
  "Not Started",
  "On Hold",
  "In Progress",
  "Not Applicable",
] as const;

export const INTEGRATION_FILTER_VALIDATION_SCORE_OPERATORS = [
  ">",
  "<",
  "=",
] as const;

export const INTEGRATION_FILTER_ENDORSEMENT_LEVEL_OPTIONS = [
  "Full Endorsement",
  "Conditional Endorsement",
  "Not Endorsed",
  "Endorsement with Minor reservations",
] as const;

export const INTEGRATION_FILTER_INTEGRATION_TYPE_OPTIONS =
  integrationOptions.map((option) => option.value);

export const INTEGRATION_FILTER_INTEGRATION_STATUS_OPTIONS = [
  "Completed",
  "In Progress",
  "On Hold",
  "Not Started",
  "Not Applicable",
] as const;

export const INTEGRATION_FILTER_INTEGRATION_STAGE_OPTIONS = [
  "Development",
  "Validation",
  "Training",
  "Onboarding",
] as const;
